import React from "react";
import ComponenteSimpleForm from "./ComponenteSimpleForm";

export default function ForzadorForm() {
  return <ComponenteSimpleForm titulo="Evaporador Cúbico" tipo="evaporadorCubico" />;
}
